import Page from '../../../components/Page';
import { Card, Container, Button } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Iconify from '../../../components/Iconify';
import ProfileCover from './ProfileCover';
import ProfileAbout from './ProfileAbout';
import { useAppSelector } from '../../../store';

const index = () => {
  const userProfile = useAppSelector((state) => state.auth.user);
  const userRole = useAppSelector(
    (state) =>
      state.active.selectedItem.organizationAccess.user_access_profile.role
  );
  const location = useLocation();

  return (
    <Page title={'User Profile'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={'Profile'}
          links={[
            location?.pathname === '/profile-view'
              ? {}
              : { name: 'Dashboard', href: '/' },
          ]}
          action={
            location?.pathname === '/profile-view' ? (
              ''
            ) : (
              <Button
                variant='contained'
                component={RouterLink}
                to={'/profile'}
                startIcon={<Iconify icon={'eva:edit-fill'} />}
              >
                {'Edit'}
              </Button>
            )
          }
        />

        {location?.pathname === '/profile-view' && (
          <div style={{ marginTop: '70px' }}></div>
        )}

        <Card
          sx={{
            mb: 3,
            height: 280,
            position: 'relative',
          }}
        >
          <ProfileCover
            myProfile={{
              fullName: `${userProfile.firstName} ${userProfile.lastName}`,
              position:
                location?.pathname === '/profile-view'
                  ? userProfile?.userRole
                  : userRole,
            }}
          />
        </Card>
        <ProfileAbout
          email={userProfile.email}
          mobileNumber={userProfile.mobileNumber}
          countryCode={userProfile.countryCallingCode}
        />
      </Container>
    </Page>
  );
};

export default index;
